import type { SliceCreator, UiActions } from './types';
import { INITIAL_STATE } from './types';

export const createUiSlice: SliceCreator<UiActions> = (set) => ({
  // Leaving floating drops any bridge path so it can't re-trigger the
  // auto-close after the widget is already dismissed / re-opened elsewhere.
  setMode: (mode) =>
    set((s) => ({
      mode,
      floatingBridgePath: mode === 'floating' ? s.floatingBridgePath : null,
    })),

  openFloatingBridge: (path) =>
    set({ mode: 'floating', floatingBridgePath: path }),

  toggleHistory: (open) =>
    set((s) => ({ historyOpen: open ?? !s.historyOpen })),

  openDraft: () =>
    set({ draftOpen: true, activeSessionId: null, mode: 'floating' }),

  closeDraft: () => set({ draftOpen: false }),

  reset: () => set(INITIAL_STATE),

  setWsReconnecting: (reconnecting) =>
    set((s) =>
      s.wsReconnecting === reconnecting ? s : { wsReconnecting: reconnecting }
    ),

  setUploadProgress: (progress) => set({ uploadProgress: progress }),

  openProfile: (candidate) => set({ profileCandidate: candidate }),

  closeProfile: () => set({ profileCandidate: null }),
});
